var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShowInfoGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Show_Info",
    "data-name": "Show Info",
    transform: "translate(-689 -670)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2516",
    "data-name": "Path 2516",
    d: "M0,0H24V24H0Z",
    transform: "translate(689 670)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2517",
    "data-name": "Path 2517",
    d: "M12,2A10,10,0,1,0,22,12,9.991,9.991,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.011,8.011,0,0,1,12,20Z",
    transform: "translate(689 670)",
    fill: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4297",
    "data-name": "Path 4297",
    d: "M294.332,157.417a1.25,1.25,0,1,1-1.249,1.25A1.251,1.251,0,0,1,294.332,157.417Zm2,12.25h-4v-1c.484-.179,1-.2,1-.735v-4.467c0-.534-.516-.618-1-.8v-1h3v6.265c0,.535.517.558,1,.735Z",
    transform: "translate(406.667 518.333)",
    fill: "#8f8f8f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowInfoGray);
export default __webpack_public_path__ + "static/media/show-info-gray.3681fcf8.svg";
export { ForwardRef as ReactComponent };